/**
 * Helpers for opening the notification center focused on the distribution and
 * farming unit the user is currently watching, instead of defaulting to "All".
 *
 * Kept free of React / Redux imports so they can be unit tested directly.
 */

/**
 * Options carry an `all` sentinel key, so a missing / empty id must never match.
 */
const findOptionByKey = (options, key) => {
  if (!key || key === 'all') {
    return null;
  }
  return options?.find((option) => option.key === key) || null;
};

/**
 * `selected_entities` holds a stale snapshot, so its ids are resolved against
 * the freshly built option lists. Anything that no longer resolves leaves the
 * corresponding filter on its "All" default rather than selecting a missing
 * entity: null return means "keep the defaults entirely".
 *
 * The farming unit options are produced lazily because they can only be built
 * once the distribution is known.
 */
const resolveWatchedSelection = ({
  distributionsOptions,
  getFarmingUnitsOptions,
  watchedDistributionId,
  watchedFarmingUnitId,
}) => {
  const distribution = findOptionByKey(
    distributionsOptions,
    watchedDistributionId,
  );
  if (!distribution) {
    return null;
  }

  return {
    distribution,
    farmingUnit: findOptionByKey(
      getFarmingUnitsOptions(distribution),
      watchedFarmingUnitId,
    ),
  };
};

module.exports = { findOptionByKey, resolveWatchedSelection };
